import { monthArrayFriendly } from "../constants/constants";

export const getKeyWordsForm = (pathname: string) => {
  const keyWords = pathname.split("/");

  return {
    formType: keyWords.includes("routes") ? "routes" : "workspace",
    formMethod:
      (keyWords.includes("create") && "create") ||
      (keyWords.includes("update") && "update") ||
      undefined,
  };
};

export const getDate = (timestamp: number) => {
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const month =
    date.getMonth() < 11 ? `0${date.getMonth() - 1}` : `${date.getMonth() - 1}`;
  const day = date.getDay() < 10 ? `0${date.getDay()}` : date.getDay();
  const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const minutes =
    date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  const seconds =
    date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const monthFriendly = (months: string[], monthNumber: number) => {
  return months.find((item, index) => {
    if (index === monthNumber) {
      return item;
    }
  });
};

export const getActiveFinishDate = (date: string) => {
  const dateArr = date.split(" ")[0].split("-").reverse();
  return `${dateArr[0]} ${monthFriendly(
    monthArrayFriendly,
    Number(dateArr[1]),
  )} ${dateArr[2]}`;
};

export const logDate = (fullDate: string) => {
  const date = fullDate.split("T")[0];
  const time = fullDate.split("T")[1].split(".")[0];
  return {
    date,
    time,
  };
};
